// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__gFbKE","label":"Section_label__1QISv","contentWrap":"Section_contentWrap__R_xWQ","footer":"Section_footer__1pX08","footerInner":"Section_footerInner__3fudH"};